<template>
  <html>
    <header>
      <Head />
    </header>

    <body class=".responsive bg--white">
      <div class="align--center pt3">
        <h2 class="mb2">question {{currentQuestionNumber}} of {{ actualNumberOfQuestions }}</h2>

        <div v-for="(question, index) in questions" :key="index">
          <Question :question="question" v-show="index + 1 == currentQuestionNumber"/>
        </div>
      </div>

      <div class="fixed left--0 bottom--0 right--0 bg--almost-white">
        <Foot />
      </div>
    </body>
  </html>
</template>

<script>
import Foot from './Foot'
import Head from './Head'
import Question from './Question'

export default {
  name: 'Quiz',
  components: { Foot, Head, Question },

  computed: {
    currentQuestionNumber() {
      return this.$store.state.currentQuestionNumber
    },

    questions() {
      return this.$store.state.quizQuestions
    },

    actualNumberOfQuestions() {
      return this.$store.state.actualNumberOfQuestions
    },

    selectedTopic() {
      return this.$store.state.selectedTopic
    },
  },

  mounted() {
    this.$store.dispatch("resetState")
    this.$store.dispatch("initQuestionPool")
    this.$store.dispatch("initQuizQuestions")
  }
}
</script>

<style lang="scss" scoped>
   @import '../assets/scss/main.scss'
</style>



// WEBPACK FOOTER //
// src/components/Quiz.vue